import { type ReactNode, type FC } from "react";
import { RoundCassette } from "../../../RoundCassette";
import * as styles from "./styles.css";

type Props = {
  jobTypeAndExperience?: ReactNode;
  heading: ReactNode;
  children: ReactNode;
};

export const StepCassette: FC<Props> = ({ jobTypeAndExperience, heading, children }) => {
  return (
    <RoundCassette className={styles.cassette}>
      {jobTypeAndExperience && (
        <p className={styles.jobTypeAndExperience}>{jobTypeAndExperience}</p>
      )}
      <h2 className={styles.heading}>{heading}</h2>
      <div className={styles.content}>{children}</div>
    </RoundCassette>
  );
};
